//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TopEntityComponentCountRoutes",
  components: {
    Icon24FillDistance: () => import('@/assets/icons/Icon24FillDistance.svg?inline')
  },
  props: {
    countRoutes: {
      type: Number,
      default: () => 0
    }
  }
}
